import axios from "axios";
const _baseURL = process.env.REACT_APP_BACKEND_BASE_URL;
export const sendEmail = async (data) => {
    try {
        const result = await axios.post(_baseURL, data);
        return result;
    } catch {
        return false;
    }
}